export const getTableMinWidth = tableWidth => {
  const cols = tableWidth.split(" ")
  let total = 0

  cols.forEach(w => {
    if (w.includes("%")) {
      total += Number(w.replace("%", "")) * 15 // approx pixel per %
    }
  })

  return total + "px"
}
